import { FaCheckCircle } from "react-icons/fa";

// Simple confirmation shown after a user is successfully added or updated.
export const SuccessModal = ({ message, onClose }) => (
  <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-40">
    <div className="bg-white rounded-lg shadow-lg w-full max-w-sm p-6 flex flex-col items-center text-center gap-3">
      <FaCheckCircle className="text-green-500 w-12 h-12" />
      <h2 className="text-lg font-bold text-gray-800">Success</h2>
      <p className="text-sm text-gray-600">{message}</p>
      <button
        onClick={onClose}
        className="mt-2 bg-jiojbmpurple text-white px-6 py-2 rounded font-semibold"
      >
        Done
      </button>
    </div>
  </div>
);
